"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WheelOfFortunePromo = exports.WheelOfFortune = void 0;
var WheelOfFortune_1 = require("./WheelOfFortune");
Object.defineProperty(exports, "WheelOfFortune", { enumerable: true, get: function () { return __importDefault(WheelOfFortune_1).default; } });
var WheelOfFortunePromo_1 = require("./WheelOfFortunePromo");
Object.defineProperty(exports, "WheelOfFortunePromo", { enumerable: true, get: function () { return __importDefault(WheelOfFortunePromo_1).default; } });
